export function LiveStatus({state}: {state: "loading" | "connected" | "closed" | "error"}) {
  const label = {loading:"连接中", connected:"已连接", closed:"已断开", error:"连接失败"}[state];
  return <span className={`live-status live-status-${state}`} role="status" data-testid="live-status"><i aria-hidden="true"/>{label}</span>;
}
